import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from 'antd';
import ls from 'local-storage';
import API from "../../Services/BaseService";
import Loading from "../../Component/Loading/Loading";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';

const ViewSellerCharges = (props) => {

    const history = useHistory();
    const { carChargesId } = props.location.state;
    const successData = useSelector(state => state.LoginReducer.payload);
    const [sellerCharge, setSellerCharge] = useState("");
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        getSellerCharge();

    }, []);

    const getSellerCharge = () => {

        let request = {

            carcharges_detail_id: carChargesId,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }


        API.post("sellerchargesView/condition", request).then(response => {

            if (response.data.success === true) {

                setSellerCharge(response.data.data[0]);
                setLoading(false);
            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }

    return (

        <div>
            {loading ? <Loading /> :
                <main id="main" className="inner-page">

                    <div className="editprofile">
                    <div class="container-fluid inner-page-space">
                            <div className="adduserpageblock">
                                <div className="section-title">
                                    <h2>View Seller Charges</h2>
                                </div>
                                <div class="back-btns">
                                <a className="back-btn-primary" onClick={() => history.push("/sellercharges")}><i className="bx bx-chevron-left"></i> Back</a>
                                </div>
                                <div className="row content">


                                    <div className="col-lg-12">
                                        <div className="col-lg-12 myprofileeditform">
                                            <form className=""  >
                                                <div className="section-title">
                                                   
                                                    <h2>Car Info</h2>
                                                </div>
                                                <div className="row">


                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.car_charges_id} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="car_charges_id" className={sellerCharge.car_charges_id != "" ? "input-has-value" : ""}>Charges #</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.type} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="type" className={sellerCharge.type != "" ? "input-has-value" : ""}>Dealer Type</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="email" defaultValue={sellerCharge.seller_dealer_id} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="dealer_id" className={sellerCharge.seller_dealer_id != "" ? "input-has-value" : ""}>Dealer #</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.vin_no} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="vin_no" className={sellerCharge.vin_no != "" ? "input-has-value" : ""}>Vin #</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.dealer_name} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="dealer_name" className={sellerCharge.dealer_name != "" ? "input-has-value" : ""}>Dealer Name</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.sellername} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="sellername" className={sellerCharge.sellername != "" ? "input-has-value" : ""}>Seller Name</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.car_id} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="car_id" className={sellerCharge.car_id != "" ? "input-has-value" : ""}>Inventory #</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.bill_of_sale_id} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="bill_of_sale_id" className={sellerCharge.bill_of_sale_id != "" ? "input-has-value" : ""}>Bill Of Sale</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.year} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="year" className={sellerCharge.year != "" ? "input-has-value" : ""}>Year</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.make} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="make" className={sellerCharge.make != "" ? "input-has-value" : ""}>Make</label>
                                                        </div>

                                                    </div>

                                                    <div className="col-sm-4 form-group">
                                                        <div className="tbox">
                                                            <input type="text" defaultValue={sellerCharge.model} className="form-control textbox" placeholder="" disabled />
                                                            <label htmlFor="model" className={sellerCharge.model != "" ? "input-has-value" : ""}>Model</label>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="section-title">

                                                    <h2>Charge Details</h2>
                                                </div>

                                                <div className="sellerChargesListtable table-responsive">

                                                    <div class="table-box">
                                                        <div className="userlisttable table-responsive">
                                                            <div class="table no-wrap">
                                                                <div class="table-responsive">

                                                                    <table className="abletable">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="th_id"> #</th>
                                                                                <th className="th_name">Charge Name</th>
                                                                                <th className="th_name">Amount</th>
                                                                                <th className="th_name">Amount Paid</th>
                                                                                <th className="th_name">Balance Due</th>
                                                                            </tr>
                                                                        </thead>


                                                                        <tr>
                                                                            <td>{sellerCharge.carcharges_detail_id}</td>
                                                                            <td>{sellerCharge.charges_name}</td>
                                                                            <td>{sellerCharge.amount_due}</td>
                                                                            <td>{sellerCharge.amount_paid}</td>
                                                                            <td>{sellerCharge.balence_due}</td>


                                                                        </tr>



                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </form>
                                        </div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section id="playstoreBlock" className="playstoreBlock">
                        <div className="container">
                            <div className="row content">
                                <div className="col-lg-12">
                                    <img src={appstore} />
                                    <img src={googleplay} />
                                </div>
                            </div>
                        </div>
                    </section>

                </main>}
        </div>

    );
};



export default ViewSellerCharges;